import { render, staticRenderFns } from "./DteStandardDataTableSection.vue?vue&type=template&id=6bc70d86"
import script from "./DteStandardDataTableSection.vue?vue&type=script&lang=js"
export * from "./DteStandardDataTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports